const BackgroundAmbience = () => (
  <>
    <div className="fixed top-[-20%] right-[-10%] w-[50%] h-[50%] bg-[var(--ambience-blue)] rounded-full blur-[60px] opacity-60 pointer-events-none will-change-transform" />
    <div className="fixed bottom-[-10%] left-[-10%] w-[40%] h-[40%] bg-[var(--ambience-purple)] rounded-full blur-[50px] opacity-60 pointer-events-none will-change-transform" />
  </>
);

export default BackgroundAmbience;
